interface PROPS {
  text: string;
}

export function G_LIST_BLOCK_HEADER__generation_tools_with_grid2d_views({ text }: PROPS) {
  /*
   *
   */

  return (
    <div className="flex flex-row items-center gap-1 px-2 h-6  bg-bar text-xs text-bar-foreground border-b first:border-t-0 border-t border-component-border">
      {text}
    </div>
  );
}
